var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("TitleWithRow", { attrs: { title: "Dados do imóvel" } }),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("validation-provider", {
            attrs: {
              rules: "required",
              mode: "lazy",
              name: _vm.nomeAba + "/Nome do imóvel"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c("Label", {
                          attrs: { label: "Nome do imóvel:", obrigatorio: true }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          class: { "input erro": errors.length },
                          attrs: { name: "Nome do imóvel" },
                          model: {
                            value: _vm.imovel.nome,
                            callback: function($$v) {
                              _vm.$set(_vm.imovel, "nome", $$v)
                            },
                            expression: "imovel.nome"
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(" " + _vm._s(errors[0]))
                        ])
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("InputRadio", {
            attrs: {
              label: "Possui CAR:",
              obrigatorio: true,
              nomeAba: _vm.nomeAba,
              widthColumn: 24,
              nameValidation: _vm.nomeAba + "/Possui CAR"
            },
            on: { input: _vm.handleNumCar },
            model: {
              value: _vm.imovel.possuiCar,
              callback: function($$v) {
                _vm.$set(_vm.imovel, "possuiCar", $$v)
              },
              expression: "imovel.possuiCar"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.imovel.possuiCar
        ? _c(
            "div",
            [
              _c("Alert", {
                attrs: {
                  type: "info",
                  title: "",
                  description:
                    "Informe abaixo o(s) número(s) do(s) CAR, ou inclua a geometria do imóvel\n      (por meio de um arquivo shapefile ou desenhando o polígono) para selecionar seu(s) CAR.",
                  colapsedMode: true
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.imovel.possuiCar === false
        ? _c(
            "div",
            [
              _c("Alert", {
                attrs: {
                  type: "warning",
                  title: "Atenção!",
                  description:
                    "Prossiga com o cadastro, porém recomendamos que consulte os órgãos\n      ambientais competentes para efetuar o cadastramento do seu imóvel.",
                  colapsedMode: true,
                  closable: false
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mt-2" },
                [
                  _c("Alert", {
                    attrs: {
                      type: "info",
                      title: "",
                      description:
                        "Inclua no mapa o arquivo shapefile ou desenhe o polígono do seu imóvel.",
                      colapsedMode: true,
                      closable: false
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        [
          _vm.imovel.possuiCar
            ? _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("validation-provider", {
                        attrs: {
                          rules: !_vm.imovel.numerosRecibosCar.length
                            ? "requiredCAR"
                            : "",
                          mode: "lazy",
                          name: _vm.nomeAba + "/Número do CAR"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("Label", {
                                    attrs: { label: "Número do CAR:" }
                                  }),
                                  _vm._v(" "),
                                  _c("el-input", {
                                    directives: [
                                      {
                                        name: "mask",
                                        rawName: "v-mask",
                                        value:
                                          "AA-XXXXXXX-XXXX.XXXX.XXXX.XXXX.XXXX.XXXX.XXXX.XXXX",
                                        expression:
                                          "'AA-XXXXXXX-XXXX.XXXX.XXXX.XXXX.XXXX.XXXX.XXXX.XXXX'"
                                      }
                                    ],
                                    staticClass: "input",
                                    attrs: {
                                      placeholder:
                                        "UF-0000000-0000.0000.0000.0000.0000.0000.0000.0000",
                                      name: "Número do CAR"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "append",
                                          fn: function() {
                                            return [
                                              _c("el-button", {
                                                staticClass: "style",
                                                attrs: {
                                                  icon: "el-icon-plus",
                                                  disabled:
                                                    _vm.numeroCar.length < 50
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.addCarNum(
                                                      _vm.numeroCar
                                                    )
                                                  }
                                                }
                                              })
                                            ]
                                          },
                                          proxy: true
                                        }
                                      ],
                                      null,
                                      true
                                    ),
                                    model: {
                                      value: _vm.numeroCar,
                                      callback: function($$v) {
                                        _vm.numeroCar = $$v
                                      },
                                      expression: "numeroCar"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "help erro" }, [
                                    _vm._v(" " + _vm._s(errors[0]))
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2795939007
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "tag-app-input marginTop" },
                        _vm._l(_vm.imovel.numerosRecibosCar, function(
                          numCar,
                          index
                        ) {
                          return _c(
                            "el-tag",
                            {
                              key: index,
                              attrs: {
                                closable: "",
                                type: "info",
                                size: "medium"
                              },
                              on: {
                                close: function($event) {
                                  return _vm.removeCarNum(numCar.numero)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(numCar.numero) +
                                  "\n          "
                              )
                            ]
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { class: _vm.imovel.possuiCar === false ? "mt-2" : "" },
            [
              _c("RegistrationMap", {
                ref: "registrationMap",
                staticClass: "mt-1",
                attrs: {
                  validation: !_vm.imovel.geoJson.length ? "required" : "",
                  showInfoMessage: _vm.imovel.possuiCar,
                  validationName: "Imóvel/Georreferenciamento"
                },
                on: { carInfo: _vm.handleCarInfo, setLayers: _vm.setLayers }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("Endereco", {
        attrs: {
          endereco: _vm.cadastro.imovel.endereco,
          nomeAba: _vm.nomeAba,
          titulo: "Endereço do imóvel:",
          exibirSwitchMesmoEndereco: true,
          enderecoCopiado: _vm.enderecoCopiado,
          tipoCadastro: _vm.tipoCadastro,
          camposObrigatorios: ["CEP", "UF", "MUNICIPIO"],
          exibirBairroComplemento: false
        }
      }),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 11 } },
            [
              _c("validation-provider", {
                attrs: {
                  rules: "required",
                  name: _vm.nomeAba + "/Comunidade ou localidade"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("Label", {
                          attrs: {
                            label: "Comunidade ou localidade:",
                            obrigatorio: true
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          staticClass: "input",
                          class: { erro: errors.length },
                          attrs: {
                            name: "comunidadeLocalidade",
                            clearable: "",
                            placeholder: "Digite a comunidade ou localidade..."
                          },
                          model: {
                            value: _vm.imovel.endereco.comunidadeLocalidade,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.imovel.endereco,
                                "comunidadeLocalidade",
                                $$v
                              )
                            },
                            expression: "imovel.endereco.comunidadeLocalidade"
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 11 } },
            [
              _c("Label", { attrs: { label: "Referência de acesso" } }),
              _vm._v(" "),
              _c("el-input", {
                staticClass: "input",
                attrs: {
                  name: "referencia",
                  clearable: "",
                  placeholder: "Digite a referência de acesso..."
                },
                model: {
                  value: _vm.imovel.endereco.referencia,
                  callback: function($$v) {
                    _vm.$set(_vm.imovel.endereco, "referencia", $$v)
                  },
                  expression: "imovel.endereco.referencia"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("TitleWithRow", { attrs: { title: "Registro do imóvel" } }),
      _vm._v(" "),
      _c("Alert", {
        attrs: {
          type: "info",
          title: "Aviso",
          description:
            'Ao responder as perguntas a seguir, você declara estar fazendo isso de forma voluntária, ciente de que as informações\n      fornecidas serão utilizadas exclusivamente para fins de análise no âmbito do Programa ABC+ Pará. Caso não queira responder,\n      selecione a opção "Não desejo especificar."',
          colapsedMode: true,
          closable: false
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-2" },
        [
          _c(
            "el-row",
            [
              _c("InputSelect", {
                attrs: {
                  label: "Situação do imóvel",
                  obrigatorio: true,
                  rulesInput: "required",
                  nomeAba: _vm.nomeAba,
                  opcoes: _vm.situacaoImovel,
                  widthColumn: 12
                },
                on: { input: _vm.handleSituacaoImovel },
                model: {
                  value: _vm.imovel.registroImovel.situacao,
                  callback: function($$v) {
                    _vm.$set(_vm.imovel.registroImovel, "situacao", $$v)
                  },
                  expression: "imovel.registroImovel.situacao"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          Boolean(_vm.imovel.registroImovel.situacao === "PROPRIETARIO")
            ? _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("validation-provider", {
                        attrs: {
                          rules: "required",
                          mode: "lazy",
                          name: _vm.nomeAba + "/Número da matrícula"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("Label", {
                                    attrs: {
                                      label: "Número da matrícula:",
                                      obrigatorio: true
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("el-input", {
                                    class: { "input erro": errors.length },
                                    attrs: { name: "Número da matrícula:" },
                                    model: {
                                      value:
                                        _vm.imovel.registroImovel
                                          .proprietarioImovel.numeroMatricula,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.imovel.registroImovel
                                            .proprietarioImovel,
                                          "numeroMatricula",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "imovel.registroImovel.proprietarioImovel.numeroMatricula"
                                    }
                                  }),
                                  _vm._v(" "),
                                  errors.length > 0
                                    ? _c("span", { staticClass: "help erro" }, [
                                        _vm._v(" " + _vm._s(errors[0]))
                                      ])
                                    : _vm._e()
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          600834428
                        )
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          Boolean(_vm.imovel.registroImovel.situacao === "POSSEIRO")
            ? _c(
                "el-row",
                [
                  _c("InputSelect", {
                    attrs: {
                      label: "Tipo de posse:",
                      obrigatorio: true,
                      rulesInput: "required",
                      opcoes: _vm.tipoPosse,
                      widthColumn: 12
                    },
                    model: {
                      value: _vm.imovel.registroImovel.posseiro.tipoPosse,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.imovel.registroImovel.posseiro,
                          "tipoPosse",
                          $$v
                        )
                      },
                      expression: "imovel.registroImovel.posseiro.tipoPosse"
                    }
                  }),
                  _vm._v(" "),
                  Boolean(
                    _vm.imovel.registroImovel.posseiro.tipoPosse === "OUTROS"
                  )
                    ? _c(
                        "el-col",
                        { staticClass: "ml-forms", attrs: { span: 11 } },
                        [
                          _c("validation-provider", {
                            attrs: {
                              rules: "required",
                              mode: "lazy",
                              name: _vm.nomeAba + "/Especificar tipo de posse"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("Label", {
                                        attrs: {
                                          label: "Especificar:",
                                          obrigatorio: true
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("el-input", {
                                        class: { "input erro": errors.length },
                                        attrs: { name: "Especificar:" },
                                        model: {
                                          value:
                                            _vm.imovel.registroImovel.posseiro
                                              .detalhePosse,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.imovel.registroImovel
                                                .posseiro,
                                              "detalhePosse",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "imovel.registroImovel.posseiro.detalhePosse"
                                        }
                                      }),
                                      _vm._v(" "),
                                      errors.length > 0
                                        ? _c(
                                            "span",
                                            { staticClass: "help erro" },
                                            [_vm._v(" " + _vm._s(errors[0]))]
                                          )
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              553824797
                            )
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          Boolean(
            _vm.imovel.registroImovel.situacao === "ASSENTADO_REFORMA_AGRARIA"
          )
            ? _c(
                "div",
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 9 } },
                        [
                          _c("validation-provider", {
                            attrs: {
                              rules: "required",
                              mode: "lazy",
                              name:
                                _vm.nomeAba +
                                "/Qual é o nome do projeto de assentamento?"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("Label", {
                                        attrs: {
                                          label:
                                            "Qual é o nome do projeto de assentamento?",
                                          obrigatorio: true
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("el-input", {
                                        class: { "input erro": errors.length },
                                        attrs: {
                                          name:
                                            "Qual é o nome do projeto de assentamento?"
                                        },
                                        model: {
                                          value:
                                            _vm.imovel.registroImovel
                                              .assentamentoReforma.nomeProjeto,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.imovel.registroImovel
                                                .assentamentoReforma,
                                              "nomeProjeto",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "imovel.registroImovel.assentamentoReforma.nomeProjeto"
                                        }
                                      }),
                                      _vm._v(" "),
                                      errors.length > 0
                                        ? _c(
                                            "span",
                                            { staticClass: "help erro" },
                                            [_vm._v(" " + _vm._s(errors[0]))]
                                          )
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              2227069134
                            )
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("InputSelect", {
                        attrs: {
                          label:
                            "Selecione o documento comprobatório do assentamento de reforma agrária",
                          opcoes: _vm.documentoReformaAgraria,
                          obrigatorio: "",
                          rulesInput: "required",
                          nameValidation:
                            _vm.nomeAba +
                            "/Documento comprobatório do assentamento de reforma agrária",
                          widthColumn: 13,
                          marginLeft: ""
                        },
                        model: {
                          value:
                            _vm.imovel.registroImovel.assentamentoReforma
                              .documento,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.imovel.registroImovel.assentamentoReforma,
                              "documento",
                              $$v
                            )
                          },
                          expression:
                            "imovel.registroImovel.assentamentoReforma.documento"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 9 } },
                        [
                          _c("validation-provider", {
                            attrs: {
                              rules: "required",
                              mode: "lazy",
                              name: _vm.nomeAba + "/Número do documento"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("Label", {
                                        attrs: {
                                          label: "Número do documento",
                                          obrigatorio: true
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("el-input", {
                                        class: { "input erro": errors.length },
                                        attrs: { name: "Número do documento" },
                                        model: {
                                          value:
                                            _vm.imovel.registroImovel
                                              .assentamentoReforma
                                              .especificacaoDocumento,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.imovel.registroImovel
                                                .assentamentoReforma,
                                              "especificacaoDocumento",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "imovel.registroImovel.assentamentoReforma.especificacaoDocumento"
                                        }
                                      }),
                                      _vm._v(" "),
                                      errors.length > 0
                                        ? _c(
                                            "span",
                                            { staticClass: "help erro" },
                                            [_vm._v(" " + _vm._s(errors[0]))]
                                          )
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              1337788279
                            )
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.imovel.registroImovel.assentamentoReforma
                        .documento === "OUTRO"
                        ? _c(
                            "el-col",
                            { staticClass: "ml-forms", attrs: { span: 11 } },
                            [
                              _c("validation-provider", {
                                attrs: {
                                  rules: "required",
                                  mode: "lazy",
                                  name:
                                    _vm.nomeAba +
                                    "/Outro documento comprobatório do assentamento de reforma agrária"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("Label", {
                                            attrs: {
                                              label: "Especificar:",
                                              obrigatorio: true
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("el-input", {
                                            class: {
                                              "input erro": errors.length
                                            },
                                            attrs: { name: "Especificar:" },
                                            model: {
                                              value:
                                                _vm.imovel.registroImovel
                                                  .assentamentoReforma
                                                  .outrosDocumentos,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.imovel.registroImovel
                                                    .assentamentoReforma,
                                                  "outrosDocumentos",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "imovel.registroImovel.assentamentoReforma.outrosDocumentos"
                                            }
                                          }),
                                          _vm._v(" "),
                                          errors.length > 0
                                            ? _c(
                                                "span",
                                                { staticClass: "help erro" },
                                                [
                                                  _vm._v(
                                                    " " + _vm._s(errors[0])
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  2918456525
                                )
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          Boolean(_vm.imovel.registroImovel.situacao === "QUILOMBOLA")
            ? _c(
                "div",
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 9 } },
                        [
                          _c("validation-provider", {
                            attrs: {
                              rules: "required",
                              mode: "lazy",
                              name: _vm.nomeAba + "/Qual é o nome do quilombo"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("Label", {
                                        attrs: {
                                          label: "Qual é o nome do quilombo?",
                                          obrigatorio: true
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("el-input", {
                                        class: { "input erro": errors.length },
                                        attrs: {
                                          name: "Qual é o nome do quilombo?"
                                        },
                                        model: {
                                          value:
                                            _vm.imovel.registroImovel.quilombola
                                              .nomeQuilombo,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.imovel.registroImovel
                                                .quilombola,
                                              "nomeQuilombo",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "imovel.registroImovel.quilombola.nomeQuilombo"
                                        }
                                      }),
                                      _vm._v(" "),
                                      errors.length > 0
                                        ? _c(
                                            "span",
                                            { staticClass: "help erro" },
                                            [_vm._v(" " + _vm._s(errors[0]))]
                                          )
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              1301664920
                            )
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("InputSelect", {
                        attrs: {
                          label: "Selecione abaixo o documento informado:",
                          obrigatorio: true,
                          rulesInput: "required",
                          opcoes: _vm.documentoQuilombo,
                          widthColumn: 13,
                          marginLeft: ""
                        },
                        model: {
                          value: _vm.imovel.registroImovel.quilombola.documento,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.imovel.registroImovel.quilombola,
                              "documento",
                              $$v
                            )
                          },
                          expression:
                            "imovel.registroImovel.quilombola.documento"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      Boolean(
                        _vm.imovel.registroImovel.situacao === "QUILOMBOLA"
                      )
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c("validation-provider", {
                                attrs: {
                                  rules: "required",
                                  mode: "lazy",
                                  name: _vm.nomeAba + "/Número do documento"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("Label", {
                                            attrs: {
                                              label: "Número do documento",
                                              obrigatorio: true
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("el-input", {
                                            class: {
                                              "input erro": errors.length
                                            },
                                            attrs: {
                                              name: "Número do documento"
                                            },
                                            model: {
                                              value:
                                                _vm.imovel.registroImovel
                                                  .quilombola
                                                  .especificacaoDocumento,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.imovel.registroImovel
                                                    .quilombola,
                                                  "especificacaoDocumento",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "imovel.registroImovel.quilombola.especificacaoDocumento"
                                            }
                                          }),
                                          _vm._v(" "),
                                          errors.length > 0
                                            ? _c(
                                                "span",
                                                { staticClass: "help erro" },
                                                [
                                                  _vm._v(
                                                    " " + _vm._s(errors[0])
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  1808317398
                                )
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      Boolean(
                        _vm.imovel.registroImovel.quilombola.documento ===
                          "OUTRO"
                      )
                        ? _c(
                            "el-col",
                            { staticClass: "ml-forms", attrs: { span: 11 } },
                            [
                              _c("validation-provider", {
                                attrs: {
                                  rules:
                                    _vm.imovel.registroImovel.quilombola
                                      .documento === "OUTRO"
                                      ? "required"
                                      : "",
                                  mode: "lazy",
                                  name: _vm.nomeAba + "/Especificar"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("Label", {
                                            attrs: {
                                              label: "Especificar",
                                              obrigatorio:
                                                _vm.imovel.registroImovel
                                                  .quilombola.documento ===
                                                "OUTRO"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("el-input", {
                                            class: {
                                              "input erro": errors.length
                                            },
                                            attrs: { name: "Especificar" },
                                            model: {
                                              value:
                                                _vm.imovel.registroImovel
                                                  .quilombola.outrosDocumentos,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.imovel.registroImovel
                                                    .quilombola,
                                                  "outrosDocumentos",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "imovel.registroImovel.quilombola.outrosDocumentos"
                                            }
                                          }),
                                          _vm._v(" "),
                                          errors.length > 0
                                            ? _c(
                                                "span",
                                                { staticClass: "help erro" },
                                                [
                                                  _vm._v(
                                                    " " + _vm._s(errors[0])
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  3585952154
                                )
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          Boolean(_vm.imovel.registroImovel.situacao === "INDIGENA")
            ? _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c("validation-provider", {
                        attrs: {
                          rules: "required",
                          mode: "lazy",
                          name: _vm.nomeAba + "/Qual é a terra indígena?"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("Label", {
                                    attrs: {
                                      label: "Qual é a terra indígena?",
                                      obrigatorio: true
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("el-input", {
                                    class: { "input erro": errors.length },
                                    attrs: { name: "Qual é a terra indígena?" },
                                    model: {
                                      value:
                                        _vm.imovel.registroImovel.indigena
                                          .terra,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.imovel.registroImovel.indigena,
                                          "terra",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "imovel.registroImovel.indigena.terra"
                                    }
                                  }),
                                  _vm._v(" "),
                                  errors.length > 0
                                    ? _c("span", { staticClass: "help erro" }, [
                                        _vm._v(" " + _vm._s(errors[0]))
                                      ])
                                    : _vm._e()
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2707861387
                        )
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { staticClass: "ml-forms", attrs: { span: 5 } },
                    [
                      _c("validation-provider", {
                        attrs: {
                          rules: "required",
                          mode: "lazy",
                          name: _vm.nomeAba + "/Qual aldeia?"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("Label", {
                                    attrs: {
                                      label: "Qual aldeia?",
                                      obrigatorio: true
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("el-input", {
                                    class: { "input erro": errors.length },
                                    attrs: { name: "Qual aldeia?" },
                                    model: {
                                      value:
                                        _vm.imovel.registroImovel.indigena
                                          .aldeia,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.imovel.registroImovel.indigena,
                                          "aldeia",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "imovel.registroImovel.indigena.aldeia"
                                    }
                                  }),
                                  _vm._v(" "),
                                  errors.length > 0
                                    ? _c("span", { staticClass: "help erro" }, [
                                        _vm._v(" " + _vm._s(errors[0]))
                                      ])
                                    : _vm._e()
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2646455935
                        )
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { staticClass: "ml-forms", attrs: { span: 10 } },
                    [
                      _c("validation-provider", {
                        attrs: {
                          rules: "required",
                          mode: "lazy",
                          name: _vm.nomeAba + "/Qual povo pertence?"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("Label", {
                                    attrs: {
                                      label: "Qual povo pertence?",
                                      obrigatorio: true
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("el-input", {
                                    class: { "input erro": errors.length },
                                    attrs: { name: "Qual povo pertence?" },
                                    model: {
                                      value:
                                        _vm.imovel.registroImovel.indigena.povo,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.imovel.registroImovel.indigena,
                                          "povo",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "imovel.registroImovel.indigena.povo"
                                    }
                                  }),
                                  _vm._v(" "),
                                  errors.length > 0
                                    ? _c("span", { staticClass: "help erro" }, [
                                        _vm._v(" " + _vm._s(errors[0]))
                                      ])
                                    : _vm._e()
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          4026197821
                        )
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          Boolean(_vm.imovel.registroImovel.situacao === "OUTROS")
            ? _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("validation-provider", {
                        attrs: {
                          rules: "required",
                          mode: "lazy",
                          name: _vm.nomeAba + "/Especifique"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("Label", {
                                    attrs: {
                                      label: "Especifique",
                                      obrigatorio: true
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("el-input", {
                                    class: { "input erro": errors.length },
                                    attrs: { name: "Especifique" },
                                    model: {
                                      value:
                                        _vm.imovel.registroImovel
                                          .especificacaoOutros,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.imovel.registroImovel,
                                          "especificacaoOutros",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "imovel.registroImovel.especificacaoOutros"
                                    }
                                  }),
                                  _vm._v(" "),
                                  errors.length > 0
                                    ? _c("span", { staticClass: "help erro" }, [
                                        _vm._v(" " + _vm._s(errors[0]))
                                      ])
                                    : _vm._e()
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1549083003
                        )
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c0ba4d38", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c0ba4d38","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App/(authenticated)/modulos/cadastro/formulario-cadastro/imovel/imovel.vue
// module id = null
// module chunks = 